import { useQuery } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import { FileCheck2, Download } from 'lucide-react';
import xacNhanRenLuyenService from '../../services/xacNhanRenLuyenService';

/** Danh sách bản "Xác nhận hoạt động đã tham gia" của chính sinh viên — tải PDF làm minh chứng nộp HTQL. */
export default function XacNhanCuaToiPanel() {
  const { data, isLoading } = useQuery({
    queryKey: ['xac-nhan-cua-toi'],
    queryFn: xacNhanRenLuyenService.cuaToi,
  });

  const taiFile = async (id, maNamHoc, soHocKy) => {
    try {
      const blob = await xacNhanRenLuyenService.taiFile(id);
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `xac_nhan_hoat_dong_HK${soHocKy}_${maNamHoc}.pdf`;
      a.click();
      URL.revokeObjectURL(url);
    } catch {
      toast.error('Không tải được file');
    }
  };

  if (isLoading || !data?.length) return null;

  return (
    <div className="px-4">
      <div className="bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden">
        <div className="px-4 py-3 border-b border-gray-100 flex items-center gap-2">
          <FileCheck2 className="w-4 h-4 text-indigo-600" />
          <h3 className="font-semibold text-gray-800 text-sm">Xác nhận hoạt động đã tham gia</h3>
        </div>
        <p className="px-4 pt-3 text-xs text-gray-500">
          File PDF đã có chữ ký xác nhận của Đoàn trường — dùng làm minh chứng khi nộp lên HTQL.
        </p>
        <div className="divide-y divide-gray-50">
          {data.map((x) => (
            <div key={x.id} className="flex items-center justify-between px-4 py-3">
              <div>
                <p className="text-sm font-medium text-gray-800">Học kỳ {x.soHocKy} - {x.maNamHoc}</p>
                <p className="text-xs text-gray-400">{x.soHoatDong} hoạt động · {x.tongDiem} điểm rèn luyện</p>
              </div>
              <button onClick={() => taiFile(x.id, x.maNamHoc, x.soHocKy)}
                className="inline-flex items-center gap-1.5 text-xs font-semibold text-indigo-600 hover:text-indigo-700 px-3 py-1.5 rounded-lg hover:bg-indigo-50">
                <Download className="w-3.5 h-3.5" /> Tải file
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
